import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


@Component({
  selector: 'app-renew-details',
  templateUrl: './renew-details.component.html',
  styleUrls: ['./renew-details.component.css']
})
export class RenewDetailsComponent implements OnInit {
  licenseDetails: any;

  constructor(private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,

  ) { }

  ngOnInit() {
    this.licenseDetails = this.data['licensedetails'];
    console.log(this.licenseDetails);
  }

}
